import { render, staticRenderFns } from "./WeChatPay.vue?vue&type=template&id=4f3f30e1&scoped=true"
import script from "./WeChatPay.vue?vue&type=script&lang=js"
export * from "./WeChatPay.vue?vue&type=script&lang=js"
import style0 from "./WeChatPay.vue?vue&type=style&index=0&id=4f3f30e1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3f30e1",
  null
  
)

export default component.exports